import { useEffect } from "react"

export const useTabTitle = (title, eventName?) => {
    useEffect(() => {
        document.title = `${title}${eventName ? ' | ' + eventName : ''}`
    }, [title, eventName])
}